import { BaseService } from "./base.service";
import { API_ENDPOINTS } from "../utils/endpoints";
import { Treatment } from "../queries/models/treatment.model";

class TreatmentsService extends BaseService {

    async getAllActive(): Promise<Treatment[]> {
        const url = `${this.endpointPath}/active`;
        return this.http.get<Treatment[]>(url).then((response: any) => response.data);
    }

    async add(request: Treatment) {
        const url = `${this.endpointPath}/create`;
        const formData = new FormData();
        request.newFiles?.forEach((f) => {
            formData.append("newFiles", f.blob!, f.name);
        });
        formData.append("comment", request.comment ?? "");
        formData.append("date", request.date?.toISOString() ?? new Date().toISOString());
        formData.append("treatmentTypeId", request.treatmentTypeId?.toString() ?? "");
        formData.append("horseTreatments", JSON.stringify(request.horseTreatments ?? []));
        return this.http.postForm<Treatment>(url, formData).then((response: any) => response.data);
    }
    async edit(request: Treatment) {
        const url = `${this.endpointPath}/update`;
        const newHorseTreatments = request.horseTreatments?.map((ht) => ({
            horseId: ht.horseId,
            comment: ht.comment ?? "",
        })) ?? [];
        const formData = new FormData();
        request.newFiles?.forEach((f) => {
            formData.append("newFiles", f.blob!, f.name);
        });
        formData.append("comment", request.comment ?? "");
        formData.append("date", request.date?.toISOString() ?? new Date().toISOString());
        formData.append("treatmentTypeId", request.treatmentTypeId?.toString() ?? "");
        formData.append("horseTreatments", JSON.stringify(newHorseTreatments ?? []));
        formData.append("id", request.id.toString());
        return this.http.putForm<Treatment>(url, formData).then((response: any) => response.data);
    }

    async delete(id: number) {
        const url = `${this.endpointPath}/delete/${id}`;
        return this.http.delete(url).then((response: any) => response.data);
    }

    async getAllActiveByHorse(horseId: number) {
        const url = `${this.endpointPath}/active/by-horse/${horseId}`;
        return this.http.get(url).then((response: any) => response.data);
    }

    async getAllActiveByDate(date: Date) {
        const url = `${this.endpointPath}/active/by-date/${date.toISOString()}`;
        return this.http.get(url).then((response: any) => response.data);
    }
}

export const treatmentsService = new TreatmentsService(API_ENDPOINTS.TREATMENTS);
